module.exports = __webpack_public_path__ + "static/img/news39.5d0d4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news39.png
// module id = cj8S
// module chunks = 0